import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoNewWhite = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 140,
	height: 108,
	viewBox: "0 0 140 108",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M88.3731 0.00805858V0L98.5316 18.8266L98.5578 18.8949H70.2561C69.939 18.8511 69.6133 18.9094 69.3485 19.0574C69.0837 19.2054 68.9008 19.4314 68.8388 19.6871C61.79 34.8196 54.7318 49.9482 47.6642 65.073L47.2107 66.0949H119.591C119.909 66.0658 120.23 66.1329 120.492 66.2833C120.753 66.4336 120.937 66.6568 121.008 66.9101C127.235 80.2208 133.466 93.5392 139.702 106.865L140 107.554H112.986C112.732 107.582 112.474 107.531 112.264 107.412C112.054 107.293 111.907 107.114 111.852 106.911C108.299 99.2569 104.733 91.6027 101.151 83.9484C101.084 83.7281 100.917 83.5364 100.683 83.411C100.45 83.2856 100.167 83.2356 99.8901 83.271H40.1241C39.8373 83.2297 39.5419 83.2795 39.2991 83.4099C39.0564 83.5402 38.8848 83.7413 38.8201 83.9714C35.2485 91.6256 31.6675 99.3143 28.0769 107.037C28.0294 107.211 27.905 107.364 27.7273 107.467C27.5496 107.571 27.331 107.618 27.1131 107.6H0C0.0417166 107.499 0.0776759 107.402 0.112114 107.309L0.112126 107.309C0.171286 107.15 0.22596 107.003 0.297623 106.865C6.1275 94.3735 11.9574 81.8856 17.7872 69.4015C28.5021 46.4388 39.2076 23.5066 49.9035 0.605095C49.9579 0.414276 50.0988 0.246974 50.2984 0.136387C50.4979 0.0257991 50.7414 -0.0200019 50.9807 0.00805858H88.3731Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M113.479 18.9883C115.379 18.9883 116.928 20.5301 116.83 22.427C115.07 56.2789 87.4837 83.1773 53.711 83.1773H39.0078V64.513H53.711C78.4692 64.513 98.5398 44.1309 98.5398 18.9883H113.479Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgLogoNewWhite);
export { ForwardRef as ReactComponent };
